import { AuthError } from '@azure/msal-browser';

import { isDevEnv, isProdEnv } from 'library/constants/constants';
import { reactPlugin } from 'main/azureInsights/config';

// MSAL v5 error messages are only links to docs, errorCode and correlationId identify the issue
export const reportMsalError = (error: unknown, source: string): void => {
	const exception = error instanceof Error ? error : new Error(String(error));
	const properties = {
		source,
		errorCode: error instanceof AuthError ? error.errorCode : undefined,
		correlationId:
			error instanceof AuthError ? error.correlationId : undefined,
	};

	if (isDevEnv) {
		console.error(
			`MSAL error in ${source} [${properties.errorCode}]: ${exception.message}`
		);
	}

	if (isProdEnv) {
		reactPlugin.trackException({ exception }, properties);
	}
};
